<template>
  <div class="hints-editor-container">
    <div>
      <h1>Editorial Add</h1>
    </div>
    <div class="flex items-center items-baseline">
      <label for="editorial name">NAME:</label>
      <div class="w-full m-2 input-wrapper">
        <input
          v-model="name"
          v-validate="'required'"
          type="text"
          name="editorial name"
          class="course-create-input"
        />
        <small class="err-msg text-red block mt-2">
          {{ veeValidateErrors.first("editorial name") }}
        </small>
      </div>
    </div>
    <div class="flex items-center items-baseline">
      <label for="editorial point">POINTS:</label>
      <div class="w-full m-2 input-wrapper">
        <input
          v-model="points"
          v-validate="'required|numeric|min_value:1'"
          type="text"
          name="editorial point"
          class="course-create-input"
        />
        <small class="err-msg text-red block mt-2">
          {{ veeValidateErrors.first("editorial point") }}
        </small>
      </div>
    </div>
    <div class="flex items-center items-baseline">
      <label class="mr-2">CMS ID:</label>
      <div class="w-full m-2 input-wrapper">
        <input v-model="cms_id" type="text" class="course-create-input" />
      </div>
    </div>
    <div class="row">
      <div class="small-8 columns mt-5">
        <simplemde
          v-model="content"
          v-validate="'required'"
          name="editorial content"
          uniqueId="edyst-editorial-content"
        >
        </simplemde>
        <small class="err-msg text-red">
          {{ veeValidateErrors.first("editorial content") }}
        </small>
      </div>
    </div>
    <div class="small-15 columns">
      <button
        type="button"
        class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-1 hover:bg-green-900"
        @click="addEditorial"
      >
        Add Editorial
      </button>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import simplemde from "@/components/simpleMarkdownEditor/SimpleMarkdown"

export default {
  components: { simplemde },
  data() {
    return {
      name: "",
      points: "",
      cms_id: "",
      type: 11,
      content: "",
    }
  },
  methods: {
    addEditorial() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$noty.error("Please fix the error and try again")
          return
        }
        const data = {
          name: this.name,
          points: this.points,
          cms_id: this.cms_id,
          type: this.type,
          content: this.content,
        }
        this.axios({
          method: "post",
          url: `${siteConfig.siteURL}questions/`,
          data,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
        })
          .then(() => {
            this.$noty.success("Editorial was created successfully")
            this.$router.push({ name: "EditorialList" })
          })
          .catch(err => {
            this.$noty.error(`Failed to create the editorial ${err}`)
          })
      })
    },
  },
}
</script>

<style scoped>
.is-invalid {
  border-color: #ff5151;
}
.input-wrapper {
  margin: 0.5rem auto;
  margin-left: 2rem;
}
.course-create-input {
  width: 57%;
}
</style>
